export const DateTimeFields = [
    "era",
    "year",
    "quarter",
    "month",
    "weekOfYear",
    "weekday",
    "day",
    "dayPeriod",
    "hour",
    "minute",
    "second",
    "timeZoneName",
];
export function getLocalizedDateTimeFields(locale) {
    const displayNames = new Intl.DisplayNames(locale, {
        type: "dateTimeField",
    });
    return DateTimeFields.reduce((acc, field) => {
        acc[field] = displayNames.of(field) ?? "";
        return acc;
    }, {});
}
//# sourceMappingURL=localized-date-time-fields.js.map